import { render } from "./LessonDetail.vue?vue&type=template&id=b027a670"
import script from "./LessonDetail.vue?vue&type=script&lang=js"
export * from "./LessonDetail.vue?vue&type=script&lang=js"
script.render = render

export default script